var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6981 0.815466C21.8862 0.947982 22 1.16442 22 1.39853V22.601C22 22.9897 21.685 23.3078 21.3 23.3078H17.1C16.715 23.3078 16.4 22.9897 16.4 22.601V20.4808H15V22.601C15 22.9897 14.685 23.3078 14.3 23.3078H1.7C1.315 23.3078 1 22.9897 1 22.601V14.12C1 13.7755 1.24937 13.4795 1.58625 13.4221L9.4 12.1102V5.63903C9.4 5.34308 9.57937 5.08247 9.855 4.97645L21.055 0.735957C21.2694 0.656448 21.51 0.687368 21.6981 0.815466ZM10.8 6.12934V12.7065C10.8 13.0511 10.5506 13.347 10.2138 13.4044L2.4 14.7163V21.8943H13.6V19.774C13.6 19.3809 13.915 19.0673 14.3 19.0673H17.1C17.485 19.0673 17.8 19.3809 17.8 19.774V21.8943H20.6V2.4189L10.8 6.12934Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6916 12.8076H9.07617V22.4999H10.6916V12.8076Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42383 15.8918H4.89236V17.2869H3.42383V15.8918ZM6.36089 15.8918H7.82942V17.2869H6.36089V15.8918ZM3.42383 18.682H4.89236V20.0771H3.42383V18.682ZM6.36089 18.682H7.82942V20.0771H6.36089V18.682ZM15.1721 4.73096H16.6406V6.12606H15.1721V4.73096ZM18.1091 4.73096H19.5777V6.12606H18.1091V4.73096ZM12.235 7.52117H13.7035V8.91627H12.235V7.52117ZM15.1721 7.52117H16.6406V8.91627H15.1721V7.52117ZM18.1091 7.52117H19.5777V8.91627H18.1091V7.52117ZM15.1721 10.3114H16.6406V11.7065H15.1721V10.3114ZM18.1091 10.3114H19.5777V11.7065H18.1091V10.3114ZM12.235 10.3114H13.7035V11.7065H12.235V10.3114ZM12.235 13.1016H13.7035V14.4967H12.235V13.1016ZM15.1721 13.1016H16.6406V14.4967H15.1721V13.1016ZM18.1091 13.1016H19.5777V14.4967H18.1091V13.1016ZM12.235 15.8918H13.7035V17.2869H12.235V15.8918ZM15.1721 15.8918H16.6406V17.2869H15.1721V15.8918ZM18.1091 15.8918H19.5777V17.2869H18.1091V15.8918Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.223e758a724749e099b1e353c8a891f4.svg";
export { ForwardRef as ReactComponent };